import { TokenCache } from './token-cache.js'
import Vue from 'vue'



let bus = new Vue({
    computed: {
        auth_header: function(){
            return TokenCache.is_stored() ? { "Authorization": "Bearer " + TokenCache.get() } : null
        }
    }
})


// Has to be strings to work properly :(
const events = {
    LOGIN_SUCCESSFUL: "LOGIN_SUCCESSFUL",
    LOGIN_FAILED: "LOGIN_FAILED",
    LOGOUT: "LOGOUT",

    USED_STORAGE_CHANGED: "USED_STORAGE_CHANGED",
    USER_PROFILE_CHANGED: "USER_PROFILE_CHANGED",
    TEAM_MEMBER_PROFILE_CHANGED: "TEAM_MEMBER_PROFILE_CHANGED",
    RELOAD_TEAM: "RELOAD_TEAM",
    RELOAD_TEAM_SETTINGS: "RELOAD_TEAM_SETTINGS",
    RELOAD_BUCKETS: "RELOAD_BUCKETS",
    TEAM_LOADED: "TEAM_LOADED",
    SPACES_LOADED: "SPACES_LOADED",

    SHOW_ALERT: "SHOW_ALERT",
    ERROR: "ERROR",
    SUCCESS: "SUCCESS",
    INFO: "INFO",
    WARNING: "WARNING",

    HIGHLIGHT_FILE: "HIGHLIGHT_FILE",
    REMOVE_FROM_FILELIST: "REMOVE_FROM_FILELIST",
    FILE_FOLDER_DRAG_START: "FILE_FOLDER_DRAG_START",
    FILE_FOLDER_DRAG_END: "FILE_FOLDER_DRAG_END",
    FILELIST_CHANGE_FOLDER_TO: "FILELIST_CHANGE_FOLDER_TO",
    FILELIST_CHANGE_FOLDER_TO_ID: "FILELIST_CHANGE_FOLDER_TO_ID",
    NAVIGATE_TO: "NAVIGATE_TO",
    RELOAD_2FA_STATUS: "RELOAD_2FA_STATUS",

    // Communication with the Share modal
    CREATE_SHARE: "CREATE_SHARE", // Open the share modal to create a new share. Payload: entities to share
    EDIT_SHARE: "EDIT_SHARE", // Open the share modal to edit an existing share. Payload: share to edit
    ENTITIES_SHARED: "ENTITIES_SHARED", // Notification that a new share was created. Payload: list of entity IDs that were shared.
    SHARE_UPDATED: "SHARE_UPDATED", // Notification that a Share was updated. Payload: updated Share

    // Communication with the file preview modal
    OPEN_FILE_VIEWER: "OPEN_FILE_VIEWER", // Open the file viewer. Payload: An object with the file to preview, a specific version ID of the file (null if latest), and an array of all preview-able files in the same context (the viewer can step between them)

    // Communication with the copy/move modal
    OPEN_COPY_MOVE: "OPEN_COPY_MOVE", // Open the namespace tree to copy/move a file or folder
    COPY_MOVE_COMPLETED: "COPY_MOVE_COMPLETED", // Notification that the file/folder was copied or moved. Payload object keys: 'action' (the original action, e.g. 'copy_file'), 'entity_id' (ID of the file/folder that was copied or moved), 'new_parent_id' (ID of the folder or null where the file/folder was copied or moved to), 'new_file_id' (ID of the new file, if it was a file copy)

    // Communication with the file/folder info modal
    OPEN_INFO_MODAL: "OPEN_INFO_MODAL",

    DOWNLOAD_FILE: "DOWNLOAD_FILE", // Download a file and save it locally. Payload: 'file', 'version_id' (may be null for the latest version)
    FILE_DOWNLOADED: "FILE_DOWNLOADED", // Notification that a file was downloaded (either saved locally or previewed). Payload: file ID (number)

    

}

export { bus, events }